export default "/images/expenses.png?5f3684f69d81fc6230f5793013b3e22a";